import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { SelectAll, radioSelector } from '../../../factories/DataGrid';
import { DeviceTypeFormatter } from '../../cellFormatters/valueFormatters';
const debug = process.env.REACT_APP_DEBUG && false;
export function getDataGridProps({ items, loading, selectedObjects, setSelectedObjects, addToSelectedObjects, isInSelectedObjects, removeFromSelectedObjects, }) {
    let dataGridProps = undefined;
    const togglePresenceInSelectedObjects = (v, id) => {
        const focusItem = items.find((item) => item.id === id);
        if (focusItem) {
            v ? addToSelectedObjects(focusItem) : removeFromSelectedObjects(focusItem);
        }
    };
    const columnMap = {
        select: {
            valueGetter: (value, row, column, apiRef) => isInSelectedObjects({ id: row.eui ?? row.id }),
            renderCell: (gridCellParams) => radioSelector({ gridCellParams, valueSetter: togglePresenceInSelectedObjects }),
            renderHeader: (gridHeaderParams) => _jsx(SelectAll, { items, selectedObjects, setSelectedObjects }),
            maxWidth: 75,
            sortable: false,
            disableColumnMenu: true,
        },
        eui: {
            valueGetter: (value, row, column, apiRef) => {
                const { eui, id } = row;
                return eui ?? id;
            },
            renderHeader: () => _jsx(_Fragment, { children: "EUI" }),
            minWidth: 160,
        },
        deviceType: {
            valueFormatter: DeviceTypeFormatter,
            renderHeader: () => _jsx(_Fragment, { children: "Device Type" }),
            minWidth: 150,
        },
        deviceId: {
            renderHeader: () => _jsx(_Fragment, { children: "Device ID" }),
            minWidth: 160,
        },
    };
    const rowToGridRow = (deviceMessage) => {
        const { id, eui, deviceType, deviceId } = deviceMessage;
        return {
            id: `${eui ?? id}`,
            eui,
            deviceType,
            deviceId,
        };
    };
    dataGridProps = {
        density: 'compact',
        // error: (e: Error) => console.log('DataGridError', e.message), // apparently not a fn but error object
        columns: Object.entries(columnMap).map(([k, v]) => ({ field: k, ...v })),
        rows: items.map(rowToGridRow),
        getRowClassName: (params) => (params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'),
        loading,
        columnHeaderHeight: 32,
        rowHeight: 32,
    };
    return dataGridProps;
}
